import React, { useEffect, useState } from 'react';
import './style.scss';
import { motion } from 'framer-motion';
import LeafletMap from '../leaflet';

const Coverage: React.FC = () => {
	const [geoJsonData, setGeoJsonData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		fetch('/geodata/RrHdLOYNr4.geojson')
			.then(response => response.json())
			.then(data => {
				setGeoJsonData(data);
				setIsLoading(false);
			})
			.catch(error => {
				console.error('Error loading GeoJSON:', error);
				setIsLoading(false);
			});
	}, []);

	return (
		<motion.section
			className="page-content__inner coverage-container"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: false, amount: 0.25 }}
			transition={{ duration: 0.5, ease: 'easeOut' }}
		>
			<motion.h2
				initial={{ opacity: 0, y: 20 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: false, amount: 0.25 }}
				transition={{ duration: 0.5, delay: 0.2 }}
			>
				Cakupan Kami
			</motion.h2>
			{isLoading && (
				<motion.div
					className="loading-circle"
					animate={{ rotate: 360 }}
					transition={{
						repeat: Infinity,
						duration: 1,
						ease: 'linear'
					}}
				/>
			)}
			<section className="coverage-map">
				{!isLoading && <LeafletMap geoJsonData={geoJsonData} />}
			</section>
		</motion.section>
	);
};

export default Coverage;
